import useInputController from '../../hooks/useInput';
import * as Yup from 'yup'
import React, { CSSProperties } from 'react';


function formatPrice(input: any) {
  // حذف همه کاراکترهای غیرعددی از ورودی
  let value = input.value.replace(/\D/g, '');

  // تبدیل رشته عددی به صورت قیمت ریال
  let formattedValue = new Intl.NumberFormat('fa-IR').format(value);

  // قراردادن مقدار فرمت شده در ورودی
  input.value = formattedValue + ' ریال';
}
//////////
export const useGeneralInput = ({
  initialvalue,
  id,
  label = '',
  isRequired = false,
  tagType = 'input',
  className = '',
  isTypeValueNumber = false,
  isTypeValuePrice = false,
  row = 4,
  inputStyle = {},
  type = '',
  placeholder
}: {
  initialvalue: string
  label: string
  className: string
  id?: string
  isRequired: boolean
  tagType: 'input' | 'textarea'
  inputStyle: CSSProperties
  isTypeValueNumber: boolean
  type: string,
  isTypeValuePrice: boolean,
  placeholder?: string,
  row: number
}) => {
  const uuid = React.useId()

  const {
    renderer: Input,
    inputValue: Value,
    inputError: Error,
    validateInput: validate,
    set_inputValue: setInputValue,
  } = useInputController({
    labelprops: {
      className: 'mb-2 h5',
      children: isRequired ? label ? label + ' * ' : '' : label + '',
    },
    holderprops: {
      className:
        className + '   m-0 p-0 d-flex flex-column justify-content-start align-items-stretch',
    },
    inputprops: {
      placeholder: placeholder,
      inputTagType: tagType,
      type: type,
      rows: row,
      id: id ?? uuid,
      onKeyPress: (e: any) => {
        if (isTypeValueNumber) {
          const reg1 = new RegExp('^[0-9]+$')
          const reg2 = new RegExp('^[۰-۹]+$')
          if (!reg1.test(e.key) && !reg2.test(e.key)) {
            e.preventDefault()
          }
        }
        return
      },
      style: {
        ...inputStyle,
      },
      isTypeValuePrice,
      isRequired,
      yupvalidationscheme: isRequired
        ? (isTypeValueNumber ? Yup.number().typeError('مقدار فیلد باید عدد باشد') : Yup.string()).required(`${label} اجباری است.`)
        : Yup.string(),
      initialvalue: initialvalue ?? '',
    },
  })

  //
  return {
    Input,
    Value,
    Error,
    validate,
    setInputValue,
  }
}
